import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop } from "@eastsideco/salvo-ts";
import Splide from "@splidejs/splide";
import { cart } from '@/theme/Cart';

@Component
export class CartUpsells extends ThemeComponent {
    @Prop({ default: 'side-cart' }) type!: string;

    private splideInstance: Splide|null = null;

    init() {
        const splideElement = this.querySelector('.splide') as HTMLElement;
        if (!splideElement) return;

        if(this.type === 'side-cart') {
    
            this.splideInstance = new Splide(splideElement, {
                type: 'slide',
                perPage: 2,
                gap: '10px',
                arrows: true
            });
        } else {
            this.splideInstance = new Splide(splideElement, {
                type: 'slide',
                perPage: 4,
                gap: '10px',
                arrows: false,
                focus: 0,
                perMove: 1,
                omitEnd: true,
                breakpoints: {
                    640: {
                        perPage: 2,
                        arrows: true
                    }
                }
            });
        }

        this.splideInstance.mount();
        
        // Add upsell button handlers
        this.initUpsellButtons();
    }

    private initUpsellButtons() {
        this.$listen(window.document as unknown as HTMLElement, 'click', async (event) => {
            const button = (event.target as HTMLElement).closest('.cart-main__upsell-action button');
            if (!button) return;

            const variantId = button.getAttribute('data-variant-id');
            if (variantId) {
                button.textContent = 'Adding';
                await this.handleUpsellAdd(Number(variantId));
            }
        });
    }

    private async handleUpsellAdd(variantId: number) {
        try {
            await cart.asInteraction(async () => {
                await cart.addItem({
                    id: variantId,
                    quantity: 1
                });
            });
        } catch (event: unknown) {
            if (event instanceof Error) {
                this.$log.error('Failed to add upsell item to cart', event.message);
            }
        }
    }

    destroy() {
        this.splideInstance?.destroy();
    }
}